import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables';
import { AGENTIC_ORCHESTRATOR_API } from '@Constants/backendConstants';
import { workflowRunColumns } from '@Constants/TableColumns';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { EnumFrontendLayoutSetting, type ApiWorkflowRun } from '@Model';
import { useTableRefetch } from '@synqo/frontend-component-library';
import { useListApi } from '@Hooks/useListApi';
import { WorkflowRunsRepository } from '@Repositories/AgenticOrchestrator';

export function FrameListWorkflowRun() {
    const { refetchRef, refetchTable } = useTableRefetch();
    useRemoteCacheInvalidation('workflow_runs', refetchTable);

    const { loadPage } = useListApi(WorkflowRunsRepository, AGENTIC_ORCHESTRATOR_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiWorkflowRun>
            layoutSettingsContext={EnumFrontendLayoutSetting.WorkflowRunsTableLayout}
            name="WorkflowRunsList"
            columns={workflowRunColumns}
            initialSorting={{ columnName: 'created_at', direction: 'desc' }}
            loader={loadPage}
            refetchRef={refetchRef}
            canCreate={false}
            useOnClickNavigation
            fullSize
        />
    );
}
